import { render } from "./OrgStructure.vue?vue&type=template&id=4e4cf223&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=4e4cf223&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=4e4cf223&lang=scss"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4cf223"]])

export default __exports__